import { ListPanelWrapper } from '../../components/ListPaneWrapper';
import { IPID } from './types';
import { SmallPanel } from './SmallPanel';
import { AiOutlineControl } from 'react-icons/ai';
import { useStyletron } from 'baseui';
import useIsMobile from '../../../hooks/useIsMobile/useIsMobile';
import { LabelMedium } from 'baseui/typography';

export function ListPanel(props: IPID) {
    const [css, theme] = useStyletron();
    const mobile = useIsMobile();
    return (
        <ListPanelWrapper icon={<AiOutlineControl size={'100%'}  color={theme.colors.backgroundPrimary}></AiOutlineControl>} {...props}>
             { !mobile && <SmallPanel {...props}></SmallPanel> }
             { mobile &&      <div className={
                css({
                    border: `${theme.colors.mono500} solid 1px`,
                    background: theme.colors.mono300,
                    padding: '5px 15px 5px 15px',
                })
            }><LabelMedium color={theme.colors.mono800}>PID</LabelMedium></div>}
        </ListPanelWrapper>
    );
}